@if (content(); as navigatorContent) {
	<!-- `tabindex="-1"` makes the kit button's host a programmatic focus target that forwards to its inner control. -->
	<eff-icon-button
		#toggleButton
		variant="outlined"
		size="md"
		tabindex="-1"
		class="ds-domain-navigator__toggle"
		[class.ds-domain-navigator__toggle--open]="isOpen()"
		[icon]="toggleIcon()"
		[ariaLabel]="toggleLabel"
		[ariaExpanded]="isOpen()"
		[ariaControls]="panelId"
		dsTestId="domain-navigator-toggle"
		(clicked)="toggle()"
	/>

	<nav
		#panel
		class="ds-domain-navigator__panel"
		[class.ds-domain-navigator__panel--open]="isOpen()"
		[id]="panelId"
		[attr.aria-label]="panelLabel"
		dsTestId="domain-navigator-panel"
	>
		<div direction="column" class="ds-domain-navigator__body" [class.ds-domain-navigator__body--open]="isOpen()">
			@if (hasOpened()) {
				<div class="ds-scrollable--y ds-scrollable--compact min-h-0 grow">
					<ng-container
						[ngComponentOutlet]="navigatorContent.content"
						[ngComponentOutletEnvironmentInjector]="navigatorContent.environmentInjector"
					/>
				</div>

				@if (footer(); as footerTemplate) {
					<footer
						vertical="center"
						class="ds-domain-navigator__footer shrink-0 px-lg py-md"
						dsTestId="domain-navigator-footer"
					>
						<ng-container [ngTemplateOutlet]="footerTemplate" />
					</footer>
				}
			}
		</div>
	</nav>
}
